import { VitalsFormatted } from '@features/components/ClinicalData/sections/utils';
import { formatClinicalTime } from '@features/components/ClinicalData/utils';
import { VitalsDataTable } from '@features/components/ClinicalData/components/ClinicalLog/components/vitals/VitalsDataTable';
import { ClinicalGalleryItem } from '@features/components/ClinicalData/components/ClinicalGalleryItem';
import { getVitalsRT } from '@features/components/ClinicalData/components/ClinicalLog/components/vitals/utils';

export const VitalsLogGrid = ({
  item,
  handlePreviewOpen,
}: {
  item: VitalsFormatted;
  handlePreviewOpen: (id: string) => void;
}) => {
  return (
    <>
      <div className="bg-base-5 rounded-lg text-white text-s-r py-1 px-2 inline-flex">
        {getVitalsRT(item.measurementMinute)}
      </div>
      <div className="flex flex-1 items-center justify-between w-full">
        <VitalsDataTable vitalParameters={item.vitalParameters} />
        <ClinicalGalleryItem
          file={item.file}
          topLabel={`${item.measurementMinute ?? 0} min`}
          topLabelClassName="bg-white text-base-5!"
          bottomLabel={formatClinicalTime(item.timestamp, item.timeZone)}
          onClick={() => handlePreviewOpen(item.file?.fileId || '')}
        />
      </div>
    </>
  );
};
